import { createContext, useContext } from 'react';

type WidgetContextValue = {
  id: string;
  collapsed: boolean;
  collapsible: boolean;
  toggle: () => void;
};

export const WidgetContext = createContext<WidgetContextValue | null>(null);

export const useWidgetContext = (): WidgetContextValue => {
  const ctx = useContext(WidgetContext);
  if (!ctx) {
    throw new Error('Widget subcomponents must be used inside <Widget>');
  }
  return ctx;
};

export const useWidgetCollapse = () => {
  const { collapsed, toggle } = useWidgetContext();
  return { collapsed, toggle };
};
